import { useState } from "react";
import SectionHead from "./SectionHead";

const FORM_URL = "https://readdy.ai/api/form/dagmdarep053ijub2do0";

export default function Subscribe() {
  const [email, setEmail] = useState("");
  const [nickname, setNickname] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = (fd.get("contact_alt") as string) || "";
    if (honeypot.trim() !== "") {
      setStatus("success");
      return;
    }
    fd.delete("contact_alt");

    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
        setNickname("");
        form.reset();
      } else {
        setStatus("error");
        setFormError(typeof serverMsg === "string" && serverMsg ? serverMsg : "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后重试。");
    }
  };

  return (
    <section className="py-12 md:py-16 bg-accent-100">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <SectionHead kicker="MEIRI·GUAWEN" title="订阅每日瓜讯" desc="每天早晚为你推送今日瓜田汇总与大事盘点，不错过任何一个热点。留下邮箱，免费订阅，随时可退订。" />
            <div className="mt-6 grid grid-cols-3 gap-4 max-w-md">
              {[
                { icon: "ri-mail-send-line", num: "2次/天", label: "准时推送" },
                { icon: "ri-shield-check-line", num: "0广告", label: "干净内容" },
                { icon: "ri-close-circle-line", num: "1键", label: "随时退订" },
              ].map((it) => (
                <div key={it.label} className="rounded-xl bg-background-50 p-4 text-center border border-accent-200">
                  <i className={`${it.icon} text-xl text-accent-700`}></i>
                  <p className="mt-2 font-label text-xl text-foreground-950">{it.num}</p>
                  <p className="text-xs text-foreground-500">{it.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl bg-background-50 border border-accent-200 p-6 md:p-8">
            <h3 className="font-heading font-bold text-xl text-foreground-950">订阅即领本周大事合订本</h3>
            {status === "success" ? (
              <div className="mt-6 rounded-xl bg-secondary-100 text-secondary-900 p-5 flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-xl"></i>
                <div>
                  <p className="font-medium text-foreground-900">订阅成功！</p>
                  <p className="text-sm mt-1">欢迎加入吃瓜群众，今天的瓜讯马上送到你的邮箱。</p>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form className="mt-6 space-y-4">
                <input type="text" name="contact_alt" className="hp-holder" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                <div>
                  <label htmlFor="nickname" className="text-sm text-foreground-700">你的昵称</label>
                  <input
                    id="nickname"
                    name="nickname"
                    type="text"
                    value={nickname}
                    onChange={(e) => setNickname(e.target.value)}
                    placeholder="怎么称呼你，瓜友？"
                    className="mt-1.5 w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 placeholder:text-foreground-400"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="text-sm text-foreground-700">电子邮箱</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="mt-1.5 w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 placeholder:text-foreground-400"
                  />
                </div>
                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="w-full whitespace-nowrap px-5 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 disabled:opacity-60 transition-colors inline-flex items-center justify-center gap-2"
                >
                  {status === "loading" ? (
                    <><i className="ri-loader-4-line animate-spin"></i> 提交中...</>
                  ) : (
                    <><i className="ri-mail-add-line"></i> 立即订阅</>
                  )}
                </button>
                {status === "error" && formError && (
                  <p className="text-sm text-primary-600 flex items-center gap-1">
                    <i className="ri-error-warning-line"></i> {formError}
                  </p>
                )}
                <p className="text-xs text-foreground-500 leading-relaxed">提交即表示你同意接收每日吃瓜的订阅内容，我们绝不发送垃圾邮件，也绝不泄露你的信息。</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}